import { useShouldStartOutageBanner } from '@ms/yammer-hooks/dist/outageBanner/';
import React, { ReactNode, Suspense, useCallback } from 'react';

import LoadableOutageBanner from './LoadableOutageBanner';

type UseOutageBanner = () => (() => ReactNode) | undefined;
export const useOutageBanner: UseOutageBanner = () => {
  const shouldStartOutageBanner = useShouldStartOutageBanner();
  const officeStatusPageUrl = 'https://go.microsoft.com/fwlink/?linkid=2195690';

  const bannerCallback = useCallback(
    () => (
      <Suspense fallback={null}>
        <LoadableOutageBanner statusPageUrl={officeStatusPageUrl} />
      </Suspense>
    ),
    []
  );

  return shouldStartOutageBanner ? bannerCallback : undefined;
};
